import React from 'react';
import {Link} from 'react-router-dom';
import content from '../seo/familyContent.json';
import siteData from '../seo/siteData.json';

export const GuideSections = ({sections, testId}) => sections.map((section, index) => (
  <section key={section.title} data-testid={`${testId}-section-${index}`}>
    <h2 className="text-base md:text-lg font-bold text-slate-800 mb-4">{section.title}</h2>
    <p className="text-sm sm:text-base text-slate-600 leading-relaxed">{section.text}</p>
  </section>
));

const Wrapper = ({testId, children}) => (
  <section data-testid={testId} className="bg-white border-t border-slate-100 py-12 sm:py-16 px-4">
    <div className="max-w-5xl mx-auto space-y-10">{children}</div>
  </section>
);

export const FamilyGuide = ({category, familySlug}) => {
  const guide = content.families[familySlug];
  const family = siteData.families[familySlug];
  if (!guide || !family || family[0] !== category) return null;
  const siblings = Object.entries(siteData.families).filter(([key, value]) => value[0] === category && key !== familySlug).slice(0, 8);
  return <Wrapper testId="family-guide">
    <p data-testid="family-guide-intro" className="text-sm sm:text-base text-slate-700 leading-relaxed">{guide.intro}</p>
    <GuideSections sections={guide.sections} testId="family-guide" />
    <section>
      <h2 className="text-base md:text-lg font-bold text-slate-800 mb-6">Questions sur la location : {family[1].toLowerCase()}</h2>
      <div className="space-y-6">{guide.faq.map((item, index) => <div key={item.question} data-testid={`family-guide-faq-${index}`}>
        <h3 className="font-semibold text-slate-800 mb-2">{item.question}</h3>
        <p className="text-sm sm:text-base text-slate-600 leading-relaxed">{item.answer}</p>
      </div>)}</div>
    </section>
    <nav aria-label="Autres matériels à louer" data-testid="family-guide-related" className="border-t border-slate-100 pt-8">
      <h2 className="text-base md:text-lg font-bold text-slate-800 mb-4">Autres matériels à louer</h2>
      <ul className="flex flex-wrap gap-x-6 gap-y-3">{siblings.map(([key, value]) => <li key={key}><Link data-testid={`family-guide-related-${key}`} to={`/equipements/${category}/${key}`} className="text-green-700 underline underline-offset-4 hover:text-green-800 transition-colors">{value[1]}</Link></li>)}</ul>
    </nav>
  </Wrapper>;
};

export const UniversGuide = ({slug}) => {
  const guide = content.univers[slug];
  if (!guide) return null;
  return <Wrapper testId="univers-guide">
    <h2 className="text-xl md:text-2xl font-bold text-slate-800">{guide.title}</h2>
    <GuideSections sections={guide.sections} testId="univers-guide" />
  </Wrapper>;
};

export const CategoryGuide = ({slug}) => {
  const guide = content.categories[slug];
  if (!guide) return null;
  return <Wrapper testId="category-guide">
    <h2 className="text-xl md:text-2xl font-bold text-slate-800">{guide.title}</h2>
    <GuideSections sections={guide.sections} testId="category-guide" />
  </Wrapper>;
};

export const UniversIndexGuide = () => <Wrapper testId="univers-index-guide">
  <h2 className="text-xl md:text-2xl font-bold text-slate-800">{content.universIndex.title}</h2>
  <GuideSections sections={content.universIndex.sections} testId="univers-index-guide" />
</Wrapper>;

export const ContactGuide = () => <Wrapper testId="contact-guide"><GuideSections sections={content.contact} testId="contact-guide" /></Wrapper>;
